import React from "react";
import { HeaderReservationStyled } from "./header-reservation.styled";
import ClickableTextProps from "../../../../../components/base/clickable-text/clickable-text";
import i18n from '../../../../../translations/strings';
import { SvgType } from "../../../../../components/base/svg/svg";
import { Colors } from "../../../../../colors";
import { useModal } from "../../../../../components/shared/modal-provider/hooks/modal-provider.hook";
import { ModalVariant } from "../../../../../components/shared/modal-provider/components/modal/modal.constants";

export interface HeaderReservationsProps {
    reservation: any
    onSearchClick: () => void
    handleCancelReservation: (message: string) => void
}


const HeaderReservation = (props: HeaderReservationsProps) => {

    const { openModal } = useModal();

    return (
      <HeaderReservationStyled.Container>
        <ClickableTextProps
          clickableText={i18n.t('handleReservation.labelSearchReservation')}
          iconLeft={SvgType.Search}
          styled={{
            color: Colors.White,
            fontFamily: 'EncodeSans-SemiBold',
            fontSize: '14px',
            textDecoration: 'none',
          }}
          onClick={props.onSearchClick}
        />

        {props.reservation.status !== 'CANCELED_BY_ADMIN' && props.reservation.status !== 'CANCELED_BY_USER' &&
          <ClickableTextProps
            clickableText={i18n.t('handleReservation.cancelReservation')}
            iconLeft={SvgType.Cancel}
            styled={{
              color: Colors.White,
              fontFamily: 'EncodeSans-Bold',
              fontSize: '14px',
              textDecoration: 'none',
            }}
            onClick={() => {
              openModal({
                title: i18n.t('common.attention'),
                message: i18n.t('handleReservation.cancelReservationWarning'),
                variant: ModalVariant.WarningTextPicker,
                onConfirmClick: props.handleCancelReservation,
              });
            }}
          />
        }
      </HeaderReservationStyled.Container>
    );
}

export default HeaderReservation
